import { Helmet } from "react-helmet";
import webIcon from "../images/Last-Section/Web.png";

export default function LastSection({ openModal }: any) {
  return (
    <div className="max-w-2xl md:max-w-full lg:mx-[2rem] bg-black text-white p-2 pt-8  flex flex-col items-center text-center space-y-6 sm:space-y-8 font-aldrich ">
      <Helmet>
        <title>Transform Your Practice | DUMOSH</title>
        <meta
          name="description"
          content="Don't let empty slots cost you! Join DUMOSH for expert digital marketing & tele-calling services to grow your medical practice."
        />
        <meta
          name="keywords"
          content="medical marketing, practice growth, patient acquisition, tele-calling, digital marketing, DUMOSH"
        />
        <meta property="og:title" content="Transform Your Practice | DUMOSH" />
        <meta
          property="og:description"
          content="Partner with DUMOSH and take control of your practice growth with performance-based pricing and expert marketing strategies."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.dumosh.in" />
        <link rel="preload" as="image" href={webIcon} />
      </Helmet>

      {/* Warning Section */}
      <div className="space-y-2 w-full">
        <h2 className="text-xl md:text-2xl lg:text-3xl xl:text-5xl text-start">
          Don&apos;t let Empty Slots cost you.
        </h2>
        <p className="text-left text-base md:text-lg lg:text-xl xl:text-3xl">
          While you&apos;re reading this, your competitors are growing their
          practices. Take control of your practice growth, Today.
        </p>
      </div>
      {/* Difference Section */}
      <div className="w-full bg-black p-4">
        <div className="text-left mb-4">
          <h3 className="text-xl md:text-2xl lg:text-3xl xl:text-5xl inline-block border border-white-800 p-1">
            THE{" "}
            <span className="font-bold">
              <b className="text-xl md:text-2xl lg:text-3xl xl:text-5xl text-left text-white font-impact">
                DUMOSH
                <span className="text-xl md:text-2xl lg:text-3xl xl:text-5xl text-left text-[#FF3E3E] ">
                  .
                </span>
              </b>
            </span>{" "}
            DIFFERENCE:
          </h3>
        </div>
        <div className="text-left space-y-2">
          <p className="text-base md:text-lg lg:text-xl xl:text-3xl">
            Performance - based pricing
          </p>
          <p className="text-base md:text-lg lg:text-xl xl:text-3xl">
            Industry - leading conversion rates
          </p>
          <p className="text-base md:text-lg lg:text-xl xl:text-3xl">
            Dedicated support team
          </p>
        </div>
      </div>
      {/* Transform CTA */}
      <div className="w-full flex items-center justify-end">
        <button
          onClick={openModal}
          className="bg-red-600 text-white m-0 py-2 px-6 md:px-14 text-base md:text-xl lg:text-2xl xl:text-3xl transform transition-transform duration-300 hover:scale-105 active:scale-95 hover:bg-red-700 whitespace-nowrap"
        >
          <p>Transform Your Practice Now</p>
        </button>

        <span className="bg-red-600 h-[2px] w-full md:w-[25%] xl:w-[35%]"></span>
      </div>
      {/* Ready Section */}
      <div className="space-y-2 text-start w-full">
        <h3 className="text-xl md:text-2xl lg:text-3xl xl:text-5xl ">
          Ready to Transform your Practice?
        </h3>
        <p className="text-xl md:text-2xl lg:text-3xl xl:text-5xl ">
          Let&apos;s Get Started!
        </p>
      </div>
      {/* Partner Section */}
      <p className="text-base md:text-lg lg:text-xl xl:text-3xl text-start w-full">
        Partner with{" "}
        <span className="font-bold font-impact">
          DUMOSH
          <span className="text-xl md:text-2xl lg:text-3xl xl:text-5xl text-left text-[#FF3E3E] ">
            .
          </span>
        </span>{" "}
        today and experience assured business growth.
      </p>
      {/* Why Wait Section */}
      <div className="space-y-4 w-full text-start">
        <div className="inline-block border border-white px-3 sm:px-4 py-1 sm:py-2">
          <h3 className="text-xl md:text-2xl lg:text-3xl xl:text-5xl">
            Why Wait?
          </h3>
        </div>
        <p className="text-base md:text-lg lg:text-xl xl:text-3xl w-full">
          Contact Us today to schedule a{" "}
          <span className="text-red-600">free consultation</span> and discover
          how our tele-calling and digital marketing services can transform your
          practice.
        </p>
      </div>
      {/* Book Session CTA */}
      <div className="w-full flex items-center justify-end">
        <button
          onClick={openModal}
          className="bg-red-600 text-white m-0 py-2 px-[4px] md:px-14 text-base md:text-xl lg:text-2xl xl:text-3xl transform transition-transform duration-300 hover:scale-105 active:scale-95 hover:bg-red-700 whitespace-nowrap"
        >
          <p>Book Your Free Strategy Session</p>
        </button>
        <span className="bg-red-600 h-[2px] w-full md:w-[20%] xl:w-[35%]"></span>
      </div>
      {/* Footer */}
      <div className="pt-6 sm:pt-8 space-y-4">
        <p className="text-base md:text-lg lg:text-xl xl:text-3xl">
          Let&apos;s work together to grow your practice one patient at a time.
        </p>
        <button
          onClick={openModal}
          className="justify-self-center text-white hover:text-red-400 flex items-center justify-center gap-2 text-base md:text-lg lg:text-xl xl:text-3xl"
        >
          <img src={webIcon} alt="web-icon" className="" /> www.dumosh.in
        </button>
      </div>
    </div>
  );
}
